import { Component, Input } from '@angular/core';
import { ConstantsService } from '../../constants.service';

@Component({
  selector: 'app-display-file',
  template: require('./display-file.component.html'),
  styles: [require('./display-file.component.scss')],
})
export class DisplayFileComponent {
  @Input() files: any[];

  constructor(
    private constants: ConstantsService,
  ) {}

  isImage(mimeType: string) {
    return this.constants.IMAGE_MIME_TYPES.indexOf(mimeType) >= 0;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/admin/shared/display-file/display-file.component.ts